import React, { useState } from 'react';
import {
	Box,
	Container,
	Grid,
	makeStyles,
	Avatar,
	Chip,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Slider,
	withStyles,
	FormControlLabel,
	Checkbox,
	Divider,
} from '@material-ui/core';
import TitleText from '../../components/reusableComponents/TitleText';
import Header from '../../components/reusableComponents/Header';
import BodyText from '../../components/reusableComponents/BodyText';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import SummaryForm from '../../components/reusableComponents/SummaryForm';
import TravellerForm from '../../components/reusableComponents/TravellerForm';
import { toggleGSTModal, toggleTermModal } from '../../reducers/UiReducer';
import { useDispatch } from 'react-redux';
import AddGSTModal from '../../components/reusableComponents/AddGSTModal';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import TermConditionModal from '../../components/reusableComponents/TermConditionModal';
import BaggageForm from '../../components/reusableComponents/BaggageForm';
import FlightSummaryForm from '../../form/FlightSummaryForm';
import Drawers from '../../components/Drawers';
import Login from '../../components/reusableComponents/Login';
import { toggleLoginModal } from '../../reducers/UiReducer';

const useStyles = makeStyles((theme) => ({
	root: {
		'& .MuiChip-sizeSmall': {
			height: 36,
		},
	},
	accodin: {
		'& .MuiAccordionSummary-content': {
			justifyContent: 'space-between',
		},
	},
}));
const GreenCheckbox = withStyles({
	root: {
		color: '#39c9bb',
		'&$checked': {
			color: '#39c9bb',
		},
	},
	checked: {},
})((props) => <Checkbox color='default' {...props} />);
const FlightSummary = () => {
	const classes = useStyles();
	const [value, setValue] = React.useState('');
	const [val, setVal] = React.useState(false);
	const [b, setB] = React.useState(false);
	const location = useLocation();
	const dispatch = useDispatch();
	const handleClick = (event) => {
		if (event.target.value === value) {
			setValue('');
		} else {
			setValue(event.target.value);
		}
	};
	console.log(value);
	const {
		baggage,
		baggageAdult2,
		baggageAdult3,
		baggageAdult4,
		baggageAdult5,
		baggageAdult6,
		baggageAdult7,
		baggageAdult8,
		baggageAdult9,
		baggageChild1,
		baggageChild2,
		baggageChild3,
		baggageChild4,
		baggageChild5,
		baggageChild6,
		baggageChild7,
		baggageChild8,
		baggageChild9,
	} = useSelector((state) => state.ui);
	const [check, setCheck] = useState(false);
	const handleCheck = (event) => {
		// if (gst) {
		dispatch(toggleTermModal(true));
		// }

		// setCheck(event.target.checked);
	};
	function timeConvert(n) {
		var num = n;
		var hours = num / 60;
		var rhours = Math.floor(hours);
		var minutes = (hours - rhours) * 60;
		var rminutes = Math.round(minutes);
		return rhours + ' hr and ' + rminutes + ' min.';
	}
	console.log(location);
	return (
		<>
			<Box
				style={{
					paddingTop: '10px',
					// background: 'white',
					position: 'absolute',
					zIndex: 99,
					height: 60,
					top: 0,
					right: 0,
					bottom: 0,
					left: 0,
				}}>
				<Container>
					<Header />
				</Container>
			</Box>

			<Box
				style={{
					backgroundColor: '#515b62',
					marginTop: 75,
					color: 'white',
					padding: 10,
				}}>
				<Container>
					<Box display='flex'>
						<TitleText two>MusafirBazar Holiday /</TitleText>
						<TitleText two textStyle={{ marginLeft: 5 }}>
							Flight / Summary
						</TitleText>
					</Box>
				</Container>
			</Box>
			<Box>
				<Container>
					<Grid container spacing={2}>
						<Grid item xs={12} lg={8}>
							<Box display='flex' justifyContent='space-between' mt={'30px'}>
								<Box>
									<TitleText
										four
										textStyle={{
											fontFamily: 'Josefin Sans, sans-serif',
											fontWeight: 500,
										}}>
										Review Your Booking
									</TitleText>
								</Box>
								<Box>
									<BodyText>Session Expires</BodyText>
								</Box>
							</Box>
							<Box
								style={{
									padding: 15,
									background: 'white',
									color: 'gray',
									border: '1px solid #e6e6e6',
									margin: '0 0 20px',
									boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
									borderRadius: '15px',
								}}>
								{location.state.OneflightData
									? location.state.OneflightData.Segments[0].map((i, index) => {
											return (
												<>
													<Box
														display='flex'
														justifyContent='space-between'
														mt={index > 0 ? '20px' : ''}>
														<Box display='flex' alignItems='center'>
															<Box alignItems='center' display='flex'>
																<TitleText
																	textStyle={{
																		fontFamily: 'Josefin Sans, sans-serif',
																		fontWeight: 500,
																	}}>
																	{i.Origin.Airport.CityCode}
																</TitleText>
																<TitleText>-</TitleText>
																<TitleText
																	textStyle={{
																		fontFamily: 'Josefin Sans, sans-serif',
																		fontWeight: 500,
																	}}>
																	{index == 0
																		? location.state.OneflightData.Segments[0]
																				.filter((i, ind) => ind === 0)
																				.map((one) => {
																					return one.Destination.Airport
																						.CityCode;
																				})
																		: index == 1
																		? location.state.OneflightData.Segments[0]
																				.filter((i, ind) => ind === 1)
																				.map((one) => {
																					return one.Destination.Airport
																						.CityCode;
																				})
																		: index == 2
																		? location.state.OneflightData.Segments[0]
																				.filter((i, ind) => ind === 2)
																				.map((one) => {
																					return one.Destination.Airport
																						.CityCode;
																				})
																		: ''}
																</TitleText>
															</Box>
															<Box
																ml={'30px'}
																style={{
																	background: '#39c9bb',
																	padding: '3px 15px',
																	borderRadius: '50px',
																	color: 'white',
																	fontFamily: 'Josefin Sans, sans-serif',
																	fontWeight: 500,
																}}>
																<TitleText two>ONWARD</TitleText>
															</Box>
														</Box>
														<Box>
															<BodyText>Fare Rule</BodyText>
														</Box>
													</Box>
													<Box mt={'20px'}>
														<BodyText>Thursday, 10 Feb 2022</BodyText>
													</Box>
													<Box
														style={{
															background: 'white',
															padding: '10px 15px',
															border: '1px solid #e6e6e6',
															marginTop: '10px',
															borderRadius: 15,
														}}>
														<Grid container>
															<Grid item xs={12} sm={9} lg={9}>
																<Box
																	display='flex'
																	justifyContent='space-between'>
																	<Box>
																		<TitleText
																			textStyle={{
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																			}}>
																			{i.Origin.Airport.CityName}(
																			{i.Origin.Airport.AirportCode})
																		</TitleText>
																		<BodyText
																			two
																			textStyle={{
																				fontFamily: 'Roboto Serif, sans-serif',
																				fontWeight: 600,
																			}}>
																			{i.Origin.Airport.AirportName}, T-3
																		</BodyText>
																	</Box>
																	<Box>
																		<TitleText
																			textStyle={{
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																			}}>
																			{i.Origin.DepTime.substr(11, 5)}
																		</TitleText>
																	</Box>
																</Box>
																<Grid container alignItems='center'>
																	<Grid item xs={6} lg={9}>
																		<Divider />
																	</Grid>
																	<Grid item xs={4} lg={3}>
																		<Box
																			style={{
																				padding: '2px 20px',
																				background: '#39c9bb',
																				color: 'white',
																				borderRadius: 15,
																			}}>
																			<BodyText one>
																				{timeConvert(i.Duration)}
																			</BodyText>
																		</Box>
																	</Grid>
																</Grid>

																<Box
																	display='flex'
																	justifyContent='space-between'>
																	<Box>
																		<TitleText
																			textStyle={{
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																			}}>
																			{i.Destination.Airport.CityName}(
																			{i.Destination.Airport.AirportCode})
																		</TitleText>
																		<BodyText
																			two
																			textStyle={{
																				fontFamily: 'Roboto Serif, sans-serif',
																				fontWeight: 600,
																			}}>
																			{i.Destination.Airport.AirportName}, T-3
																		</BodyText>
																	</Box>
																	<Box>
																		<TitleText
																			textStyle={{
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																			}}>
																			{i.Destination.ArrTime.substr(11, 5)}
																		</TitleText>
																	</Box>
																</Box>
															</Grid>
															<Grid item xs={12} sm={3} lg={3}>
																<Box textAlign='center'>
																	{/* <img
																		width='50px'
																		height='25px'
																		src={
																			i.Airline.AirlineName == 'SpiceJet'
																				? spice
																				: i.Airline.AirlineName == 'Indigo'
																				? indigo
																				: i.Airline.AirlineName == 'GO FIRST'
																				? go_first
																				: i.Airline.AirlineName == 'Air India'
																				? air
																				: i.Airline.AirlineName == 'Air Asia'
																				? airasia
																				: i.Airline.AirlineName == 'Vistara'
																				? vistara
																				: ''
																		}></img> */}
																	<BodyText two>
																		{i.Airline.AirlineName}
																	</BodyText>
																	<BodyText two>
																		{i.Airline.AirlineCode}-
																		{i.Airline.FlightNumber}| Economy
																	</BodyText>
																	<BodyText two>
																		Check-In : 1Pc - 15Kgs
																	</BodyText>
																	<BodyText two>Cabin : 7Kgs</BodyText>
																</Box>
															</Grid>
														</Grid>
													</Box>
												</>
											);
									  })
									: ''}
								{location.state.flightData
									? location.state.flightData[0].Segments[0].map((i, index) => {
											return (
												<>
													<Box
														display='flex'
														justifyContent='space-between'
														mt={index > 0 ? '20px' : ''}>
														<Box display='flex' alignItems='center'>
															<Box alignItems='center' display='flex'>
																<TitleText
																	textStyle={{
																		fontFamily: 'Josefin Sans, sans-serif',
																		fontWeight: 500,
																	}}>
																	{i.Origin.Airport.CityCode}
																</TitleText>
																<TitleText>-</TitleText>
																<TitleText
																	textStyle={{
																		fontFamily: 'Josefin Sans, sans-serif',
																		fontWeight: 500,
																	}}>
																	{index == 0
																		? location.state.flightData[0].Segments[0]
																				.filter((i, ind) => ind === 0)
																				.map((one) => {
																					return one.Destination.Airport
																						.CityCode;
																				})
																		: index == 1
																		? location.state.flightData[0].Segments[0]
																				.filter((i, ind) => ind === 1)
																				.map((one) => {
																					return one.Destination.Airport
																						.CityCode;
																				})
																		: index == 2
																		? location.state.flightData[0].Segments[0]
																				.filter((i, ind) => ind === 2)
																				.map((one) => {
																					return one.Destination.Airport
																						.CityCode;
																				})
																		: ''}
																</TitleText>
															</Box>
															<Box
																ml={'30px'}
																style={{
																	background: '#39c9bb',
																	padding: '3px 15px',
																	borderRadius: '50px',
																	color: 'white',
																	fontFamily: 'Josefin Sans, sans-serif',
																	fontWeight: 500,
																}}>
																<TitleText two>ONWARD</TitleText>
															</Box>
														</Box>
														<Box>
															<BodyText>Fare Rule</BodyText>
														</Box>
													</Box>
													<Box mt={'20px'}>
														<BodyText>Thursday, 10 Feb 2022</BodyText>
													</Box>
													<Box
														style={{
															background: 'white',
															padding: '10px 15px',
															border: '1px solid #e6e6e6',
															marginTop: '10px',
															borderRadius: 15,
														}}>
														<Grid container>
															<Grid item xs={12} sm={9} lg={9}>
																<Box
																	display='flex'
																	justifyContent='space-between'>
																	<Box>
																		<TitleText
																			textStyle={{
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																			}}>
																			{i.Origin.Airport.CityName}(
																			{i.Origin.Airport.AirportCode})
																		</TitleText>
																		<BodyText
																			two
																			textStyle={{
																				fontFamily: 'Roboto Serif, sans-serif',
																				fontWeight: 600,
																			}}>
																			{i.Origin.Airport.AirportName}, T-3
																		</BodyText>
																	</Box>
																	<Box>
																		<TitleText
																			textStyle={{
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																			}}>
																			{i.Origin.DepTime.substr(11, 5)}
																		</TitleText>
																	</Box>
																</Box>
																<Grid container alignItems='center'>
																	<Grid item xs={6} lg={9}>
																		<Divider />
																	</Grid>
																	<Grid item xs={4} lg={3}>
																		<Box
																			style={{
																				padding: '2px 20px',
																				background: '#39c9bb',
																				color: 'white',
																				borderRadius: 15,
																			}}>
																			<BodyText one>
																				{timeConvert(i.Duration)}
																			</BodyText>
																		</Box>
																	</Grid>
																</Grid>

																<Box
																	display='flex'
																	justifyContent='space-between'>
																	<Box>
																		<TitleText
																			textStyle={{
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																			}}>
																			{i.Destination.Airport.CityName}(
																			{i.Destination.Airport.AirportCode})
																		</TitleText>
																		<BodyText
																			two
																			textStyle={{
																				fontFamily: 'Roboto Serif, sans-serif',
																				fontWeight: 600,
																			}}>
																			{i.Destination.Airport.AirportName}, T-3
																		</BodyText>
																	</Box>
																	<Box>
																		<TitleText
																			textStyle={{
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																			}}>
																			{i.Destination.ArrTime.substr(11, 5)}
																		</TitleText>
																	</Box>
																</Box>
															</Grid>
															<Grid item xs={12} sm={3} lg={3}>
																<Box textAlign='center'>
																	{/* <img
																		width='50px'
																		height='25px'
																		src={
																			i.Airline.AirlineName == 'SpiceJet'
																				? spice
																				: i.Airline.AirlineName == 'Indigo'
																				? indigo
																				: i.Airline.AirlineName == 'GO FIRST'
																				? go_first
																				: i.Airline.AirlineName == 'Air India'
																				? air
																				: i.Airline.AirlineName == 'Air Asia'
																				? airasia
																				: i.Airline.AirlineName == 'Vistara'
																				? vistara
																				: ''
																		}></img> */}
																	<BodyText two>
																		{i.Airline.AirlineName}
																	</BodyText>
																	<BodyText two>
																		{i.Airline.AirlineCode}-
																		{i.Airline.FlightNumber}| Economy
																	</BodyText>
																	<BodyText two>
																		Check-In : 1Pc - 15Kgs
																	</BodyText>
																	<BodyText two>Cabin : 7Kgs</BodyText>
																</Box>
															</Grid>
														</Grid>
													</Box>
												</>
											);
									  })
									: ''}
								{/* <Box display='flex' justifyContent='space-between'>
									<Box display='flex' alignItems='center'>
										<Box alignItems='center' display='flex'>
											<TitleText
												textStyle={{
													fontFamily: 'Josefin Sans, sans-serif',
													fontWeight: 500,
												}}>
												{location.state.flightData
													? location.state.flightData[0].Segments[0].map(
															(i) => {
																return i.Origin.Airport.CityCode;
															}
													  )
													: location.state.OneflightData
													? location.state.OneflightData.Segments[0].map(
															(i) => {
																return i.Origin.Airport.CityCode;
															}
													  )
													: ''}
											</TitleText>
											<TitleText>-</TitleText>
											<TitleText
												textStyle={{
													fontFamily: 'Josefin Sans, sans-serif',
													fontWeight: 500,
												}}>
												{location.state.flightData
													? location.state.flightData[0].Segments[0].map(
															(i) => {
																return i.Destination.Airport.CityCode;
															}
													  )
													: location.state.OneflightData
													? location.state.OneflightData.Segments[0].map(
															(i) => {
																return i.Destination.Airport.CityCode;
															}
													  )
													: ''}
											</TitleText>
										</Box>
										<Box
											ml={'30px'}
											style={{
												background: '#39c9bb',
												padding: '3px 15px',
												borderRadius: '50px',
												color: 'white',
												fontFamily: 'Josefin Sans, sans-serif',
												fontWeight: 500,
											}}>
											<TitleText two>ONWARD</TitleText>
										</Box>
									</Box>
									<Box>
										<BodyText>Fare Rule</BodyText>
									</Box>
								</Box>
								<Box mt={'20px'}>
									<BodyText>Thursday, 10 Feb 2022</BodyText>
								</Box>
								<Box
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										borderRadius: 15,
									}}>
									<Grid container>
										<Grid item xs={12} sm={9} lg={9}>
											<Box display='flex' justifyContent='space-between'>
												<Box>
													<TitleText
														textStyle={{
															fontFamily: 'Josefin Sans, sans-serif',
															fontWeight: 500,
														}}>
														{location.state.flightData
															? location.state.flightData[0].Segments[0].map(
																	(i) => {
																		return i.Origin.Airport.CityName;
																	}
															  )
															: location.state.OneflightData
															? location.state.OneflightData.Segments[0].map(
																	(i) => {
																		return i.Origin.Airport.CityName;
																	}
															  )
															: ''}{' '}
														(
														{location.state.flightData
															? location.state.flightData[0].Segments[0].map(
																	(i) => {
																		return i.Origin.Airport.AirportCode;
																	}
															  )
															: location.state.OneflightData
															? location.state.OneflightData.Segments[0].map(
																	(i) => {
																		return i.Origin.Airport.AirportCode;
																	}
															  )
															: ''}
														)
													</TitleText>
													<BodyText
														two
														textStyle={{
															fontFamily: 'Roboto Serif, sans-serif',
															fontWeight: 600,
														}}>
														{location.state.flightData
															? location.state.flightData[0].Segments[0].map(
																	(i) => {
																		return i.Origin.Airport.AirportName;
																	}
															  )
															: location.state.OneflightData
															? location.state.OneflightData.Segments[0].map(
																	(i) => {
																		return i.Origin.Airport.AirportName;
																	}
															  )
															: ''}
														, T-3
													</BodyText>
												</Box>
												<Box>
													<TitleText
														textStyle={{
															fontFamily: 'Josefin Sans, sans-serif',
															fontWeight: 500,
														}}>
														{location.state.flightData
															? location.state.flightData[0].Segments[0].map(
																	(i) => {
																		return i.Origin.DepTime.substr(11, 5);
																	}
															  )
															: location.state.OneflightData
															? location.state.OneflightData.Segments[0].map(
																	(i) => {
																		return i.Origin.DepTime.substr(11, 5);
																	}
															  )
															: ''}
													</TitleText>
												</Box>
											</Box>
											<Grid container alignItems='center'>
												<Grid item xs={6} lg={9}>
													<Divider />
												</Grid>
												<Grid item xs={4} lg={3}>
													<Box
														style={{
															padding: '2px 20px',
															background: '#39c9bb',
															color: 'white',
															borderRadius: 15,
														}}>
														<BodyText one>
															{location.state.flightData
																? timeConvert(
																		location.state.flightData[0].Segments[0].map(
																			(i) => {
																				return i.Duration;
																			}
																		)
																  )
																: location.state.OneflightData
																? timeConvert(
																		location.state.OneflightData.Segments[0].map(
																			(i) => {
																				return i.Duration;
																			}
																		)
																  )
																: ''}
														</BodyText>
													</Box>
												</Grid>
											</Grid>

											<Box display='flex' justifyContent='space-between'>
												<Box>
													<TitleText
														textStyle={{
															fontFamily: 'Josefin Sans, sans-serif',
															fontWeight: 500,
														}}>
														{location.state.flightData
															? location.state.flightData[0].Segments[0].map(
																	(i) => {
																		return i.Destination.Airport.CityName;
																	}
															  )
															: location.state.OneflightData
															? location.state.OneflightData.Segments[0].map(
																	(i) => {
																		return i.Destination.Airport.CityName;
																	}
															  )
															: ''}{' '}
														(
														{location.state.flightData
															? location.state.flightData[0].Segments[0].map(
																	(i) => {
																		return i.Destination.Airport.AirportCode;
																	}
															  )
															: location.state.OneflightData
															? location.state.OneflightData.Segments[0].map(
																	(i) => {
																		return i.Destination.Airport.AirportCode;
																	}
															  )
															: ''}
														)
													</TitleText>
													<BodyText
														two
														textStyle={{
															fontFamily: 'Roboto Serif, sans-serif',
															fontWeight: 600,
														}}>
														{location.state.flightData
															? location.state.flightData[0].Segments[0].map(
																	(i) => {
																		return i.Destination.Airport.AirportName;
																	}
															  )
															: location.state.OneflightData
															? location.state.OneflightData.Segments[0].map(
																	(i) => {
																		return i.Destination.Airport.AirportName;
																	}
															  )
															: ''}
														, T-3
													</BodyText>
												</Box>
												<Box>
													<TitleText
														textStyle={{
															fontFamily: 'Josefin Sans, sans-serif',
															fontWeight: 500,
														}}>
														{location.state.flightData
															? location.state.flightData[0].Segments[0].map(
																	(i) => {
																		return i.Destination.ArrTime.substr(11, 5);
																	}
															  )
															: location.state.OneflightData
															? location.state.OneflightData.Segments[0].map(
																	(i) => {
																		return i.Destination.ArrTime.substr(11, 5);
																	}
															  )
															: ''}
													</TitleText>
												</Box>
											</Box>
										</Grid>
										<Grid item xs={12} sm={3} lg={3}>
											<Box textAlign='center'>
												<img src={spice}></img>
												<BodyText two>
													{location.state.flightData
														? location.state.flightData[0].Segments[0].map(
																(i) => {
																	return i.Airline.AirlineName;
																}
														  )
														: location.state.OneflightData
														? location.state.OneflightData.Segments[0].map(
																(i) => {
																	return i.Airline.AirlineName;
																}
														  )
														: ''}
												</BodyText>
												<BodyText two>
													{location.state.flightData
														? location.state.flightData[0].Segments[0].map(
																(i) => {
																	return i.Airline.AirlineCode;
																}
														  )
														: location.state.OneflightData
														? location.state.OneflightData.Segments[0].map(
																(i) => {
																	return i.Airline.AirlineCode;
																}
														  )
														: ''}
													-
													{location.state.flightData
														? location.state.flightData[0].Segments[0].map(
																(i) => {
																	return i.Airline.FlightNumber;
																}
														  )
														: location.state.OneflightData
														? location.state.OneflightData.Segments[0].map(
																(i) => {
																	return i.Airline.FlightNumber;
																}
														  )
														: ''}{' '}
													| Economy
												</BodyText>
												<BodyText two>Check-In : 1Pc - 15Kgs</BodyText>
												<BodyText two>Cabin : 7Kgs</BodyText>
											</Box>
										</Grid>
									</Grid>
								</Box> */}
								{/* {location.state.Returnflight ? (
									<>
										<Grid
											container
											style={{ marginTop: 20, alignItems: 'center' }}>
											<Grid item xs={3}>
												<Divider />
											</Grid>
											<Grid item xs={6}>
												<Box
													style={{
														padding: '8px',
														background: '#def6f4',
														color: 'black',
														borderRadius: 50,
														textAlign: 'center',
														border: '1px solid #39c9bb',
													}}>
													<BodyText
														textStyle={{
															fontFamily: 'Josefin Sans, sans-serif',
															fontWeight: 500,
														}}>
														Layover Time: 2hr 55mins at
													</BodyText>
												</Box>
											</Grid>
											<Grid item xs={3}>
												<Divider />
											</Grid>
										</Grid>
									</>
								) : (
									''
								)}
								{location.state.Returnflight ? (
									<>
										<Box
											style={{
												background: 'white',
												padding: '10px 15px',
												border: '1px solid #e6e6e6',
												marginTop: '20px',
												borderRadius: 15,
											}}>
											<Grid container>
												<Grid item xs={12} sm={9} lg={9}>
													<Box display='flex' justifyContent='space-between'>
														<Box>
															<TitleText
																textStyle={{
																	fontFamily: 'Josefin Sans, sans-serif',
																	fontWeight: 500,
																}}>
																{location.state.Returnflight
																	? location.state.Returnflight[0].Segments[0].map(
																			(i) => {
																				return i.Origin.Airport.CityName;
																			}
																	  )
																	: ''}{' '}
																(
																{location.state.Returnflight
																	? location.state.Returnflight[0].Segments[0].map(
																			(i) => {
																				return i.Origin.Airport.AirportCode;
																			}
																	  )
																	: ''}
																)
															</TitleText>
															<BodyText
																textStyle={{
																	fontFamily: 'Roboto Serif, sans-serif',
																	fontWeight: 600,
																}}>
																{location.state.Returnflight
																	? location.state.Returnflight[0].Segments[0].map(
																			(i) => {
																				return i.Origin.Airport.AirportName;
																			}
																	  )
																	: ''}
																, T-3
															</BodyText>
														</Box>
														<Box>
															<TitleText
																textStyle={{
																	fontFamily: 'Josefin Sans, sans-serif',
																	fontWeight: 500,
																}}>
																{location.state.Returnflight
																	? location.state.Returnflight[0].Segments[0].map(
																			(i) => {
																				return i.Origin.DepTime.substr(11, 5);
																			}
																	  )
																	: ''}
															</TitleText>
														</Box>
													</Box>
													<Grid container alignItems='center'>
														<Grid item xs={9}>
															<Divider />
														</Grid>
														<Grid item xs={3}>
															<Box
																style={{
																	padding: '2px 20px',
																	background: '#39c9bb',
																	color: 'white',
																	borderRadius: 15,
																}}>
																<BodyText one>
																	{location.state.Returnflight
																		? timeConvert(
																				location.state.Returnflight[0].Segments[0].map(
																					(i) => {
																						return i.Duration;
																					}
																				)
																		  )
																		: ''}
																</BodyText>
															</Box>
														</Grid>
													</Grid>

													<Box display='flex' justifyContent='space-between'>
														<Box>
															<TitleText
																textStyle={{
																	fontFamily: 'Josefin Sans, sans-serif',
																	fontWeight: 500,
																}}>
																{location.state.Returnflight
																	? location.state.Returnflight[0].Segments[0].map(
																			(i) => {
																				return i.Destination.Airport.CityName;
																			}
																	  )
																	: ''}{' '}
																(
																{location.state.Returnflight
																	? location.state.Returnflight[0].Segments[0].map(
																			(i) => {
																				return i.Destination.Airport
																					.AirportCode;
																			}
																	  )
																	: ''}
																)
															</TitleText>
															<BodyText
																two
																textStyle={{
																	fontFamily: 'Roboto Serif, sans-serif',
																	fontWeight: 600,
																}}>
																{location.state.Returnflight
																	? location.state.Returnflight[0].Segments[0].map(
																			(i) => {
																				return i.Destination.Airport
																					.AirportName;
																			}
																	  )
																	: ''}
																, T-3
															</BodyText>
														</Box>
														<Box>
															<TitleText
																textStyle={{
																	fontFamily: 'Josefin Sans, sans-serif',
																	fontWeight: 500,
																}}>
																{location.state.Returnflight
																	? location.state.Returnflight[0].Segments[0].map(
																			(i) => {
																				return i.Destination.ArrTime.substr(
																					11,
																					5
																				);
																			}
																	  )
																	: ''}
															</TitleText>
														</Box>
													</Box>
												</Grid>
												<Grid item xs={12} sm={3} lg={3}>
													<Box textAlign='center'>
														<img src={spice}></img>
														<BodyText two>
															{location.state.Returnflight
																? location.state.Returnflight[0].Segments[0].map(
																		(i) => {
																			return i.Airline.AirlineName;
																		}
																  )
																: ''}
														</BodyText>
														<BodyText two>
															{location.state.Returnflight
																? location.state.Returnflight[0].Segments[0].map(
																		(i) => {
																			return i.Airline.AirlineCode;
																		}
																  )
																: ''}
															-
															{location.state.Returnflight
																? location.state.Returnflight[0].Segments[0].map(
																		(i) => {
																			return i.Airline.FlightNumber;
																		}
																  )
																: ''}{' '}
															| Economy
														</BodyText>
														<BodyText two>Check-In : 1Pc - 15Kgs</BodyText>
														<BodyText two>Cabin : 7Kgs</BodyText>
													</Box>
												</Grid>
											</Grid>
										</Box>
									</>
								) : (
									''
								)} */}
							</Box>
							{location.state.Returnflight ? (
								<Box
									style={{
										padding: 15,
										background: 'white',
										color: 'gray',
										border: '1px solid #e6e6e6',
										margin: '0 0 20px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '15px',
									}}>
									{location.state.Returnflight
										? location.state.Returnflight[0].Segments[0].map(
												(i, index) => {
													return (
														<>
															<Box
																display='flex'
																justifyContent='space-between'
																mt={index > 0 ? '20px' : ''}>
																<Box display='flex' alignItems='center'>
																	<Box alignItems='center' display='flex'>
																		<TitleText
																			textStyle={{
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																			}}>
																			{i.Origin.Airport.CityCode}
																		</TitleText>
																		<TitleText>-</TitleText>
																		<TitleText
																			textStyle={{
																				fontFamily: 'Josefin Sans, sans-serif',
																				fontWeight: 500,
																			}}>
																			{index == 0
																				? location.state.Returnflight[0].Segments[0]
																						.filter((i, ind) => ind === 0)
																						.map((one) => {
																							return one.Destination.Airport
																								.CityCode;
																						})
																				: index == 1
																				? location.state.Returnflight[0].Segments[0]
																						.filter((i, ind) => ind === 1)
																						.map((one) => {
																							return one.Destination.Airport
																								.CityCode;
																						})
																				: index == 2
																				? location.state.Returnflight[0].Segments[0]
																						.filter((i, ind) => ind === 2)
																						.map((one) => {
																							return one.Destination.Airport
																								.CityCode;
																						})
																				: ''}
																		</TitleText>
																	</Box>
																	<Box
																		ml={'30px'}
																		style={{
																			background: '#39c9bb',
																			padding: '3px 15px',
																			borderRadius: '50px',
																			color: 'white',
																			fontFamily: 'Josefin Sans, sans-serif',
																			fontWeight: 500,
																		}}>
																		<TitleText two>RETURN</TitleText>
																	</Box>
																</Box>
																<Box>
																	<BodyText>Fare Rule</BodyText>
																</Box>
															</Box>
															<Box mt={'20px'}>
																<BodyText>Thursday, 10 Feb 2022</BodyText>
															</Box>
															<Box
																style={{
																	background: 'white',
																	padding: '10px 15px',
																	border: '1px solid #e6e6e6',
																	marginTop: '10px',
																	borderRadius: 15,
																}}>
																<Grid container>
																	<Grid item xs={12} sm={9} lg={9}>
																		<Box
																			display='flex'
																			justifyContent='space-between'>
																			<Box>
																				<TitleText
																					textStyle={{
																						fontFamily:
																							'Josefin Sans, sans-serif',
																						fontWeight: 500,
																					}}>
																					{i.Origin.Airport.CityName}(
																					{i.Origin.Airport.AirportCode})
																				</TitleText>
																				<BodyText
																					two
																					textStyle={{
																						fontFamily:
																							'Roboto Serif, sans-serif',
																						fontWeight: 600,
																					}}>
																					{i.Origin.Airport.AirportName}, T-3
																				</BodyText>
																			</Box>
																			<Box>
																				<TitleText
																					textStyle={{
																						fontFamily:
																							'Josefin Sans, sans-serif',
																						fontWeight: 500,
																					}}>
																					{i.Origin.DepTime.substr(11, 5)}
																				</TitleText>
																			</Box>
																		</Box>
																		<Grid container alignItems='center'>
																			<Grid item xs={6} lg={9}>
																				<Divider />
																			</Grid>
																			<Grid item xs={4} lg={3}>
																				<Box
																					style={{
																						padding: '2px 20px',
																						background: '#39c9bb',
																						color: 'white',
																						borderRadius: 15,
																					}}>
																					<BodyText one>
																						{timeConvert(i.Duration)}
																					</BodyText>
																				</Box>
																			</Grid>
																		</Grid>

																		<Box
																			display='flex'
																			justifyContent='space-between'>
																			<Box>
																				<TitleText
																					textStyle={{
																						fontFamily:
																							'Josefin Sans, sans-serif',
																						fontWeight: 500,
																					}}>
																					{i.Destination.Airport.CityName}(
																					{i.Destination.Airport.AirportCode})
																				</TitleText>
																				<BodyText
																					two
																					textStyle={{
																						fontFamily:
																							'Roboto Serif, sans-serif',
																						fontWeight: 600,
																					}}>
																					{i.Destination.Airport.AirportName},
																					T-3
																				</BodyText>
																			</Box>
																			<Box>
																				<TitleText
																					textStyle={{
																						fontFamily:
																							'Josefin Sans, sans-serif',
																						fontWeight: 500,
																					}}>
																					{i.Destination.ArrTime.substr(11, 5)}
																				</TitleText>
																			</Box>
																		</Box>
																	</Grid>
																	<Grid item xs={12} sm={3} lg={3}>
																		<Box textAlign='center'>
																			{/* <img
																				width='50px'
																				height='25px'
																				src={
																					i.Airline.AirlineName == 'SpiceJet'
																						? spice
																						: i.Airline.AirlineName == 'Indigo'
																						? indigo
																						: i.Airline.AirlineName ==
																						  'GO FIRST'
																						? go_first
																						: i.Airline.AirlineName ==
																						  'Air India'
																						? air
																						: i.Airline.AirlineName ==
																						  'Air Asia'
																						? airasia
																						: i.Airline.AirlineName == 'Vistara'
																						? vistara
																						: ''
																				}></img> */}
																			<BodyText two>
																				{i.Airline.AirlineName}
																			</BodyText>
																			<BodyText two>
																				{i.Airline.AirlineCode}-
																				{i.Airline.FlightNumber}| Economy
																			</BodyText>
																			<BodyText two>
																				Check-In : 1Pc - 15Kgs
																			</BodyText>
																			<BodyText two>Cabin : 7Kgs</BodyText>
																		</Box>
																	</Grid>
																</Grid>
															</Box>
														</>
													);
												}
										  )
										: ''}
								</Box>
							) : (
								''
							)}
							<Box display='flex' alignItems='center'>
								<TitleText
									four
									textStyle={{
										fontFamily: 'Josefin Sans, sans-serif',
										fontWeight: 500,
									}}>
									Contact Information{' '}
								</TitleText>
								<TitleText
									textStyle={{
										marginLeft: 10,
										fontFamily: 'Josefin Sans, sans-serif',
										fontWeight: 500,
									}}>
									<span
										style={{
											color: 'blue',
											fontWeight: 500,
											cursor: 'pointer',
										}}
										onClick={() => dispatch(toggleLoginModal(true))}>
										Sign in
									</span>{' '}
									to book faster and avail offers.{' '}
								</TitleText>
							</Box>
							<FlightSummaryForm />
							{/* <Box
								style={{
									background: 'white',
									padding: '10px 15px',
									border: '1px solid #e6e6e6',
									marginTop: '10px',
									boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
									borderRadius: '15px',
								}}>
								<Box display='flex' alignItems='center'>
									<TitleText>Contact Details</TitleText>
									<BodyText textStyle={{ marginLeft: 20 }}>
										Your booking details will be sent to this email ID & mobile
										number.
									</BodyText>
								</Box>
								<SummaryForm />
							</Box> */}
							{/* <Box
								style={{
									background: 'white',
									padding: '10px 15px',
									border: '1px solid #e6e6e6',
									marginTop: '10px',
									boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
									borderRadius: '15px',
								}}>
								<Box display='flex' alignItems='center'>
									<TitleText>Contact Details</TitleText>
									<BodyText textStyle={{ marginLeft: 20 }}>
										Your booking details will be sent to this email ID & mobile
										number.
									</BodyText>
								</Box>
								<TravellerForm />
							</Box> */}
							{/* <Box
								style={{
									background: 'white',
									padding: '10px 15px',
									border: '1px solid #e6e6e6',
									marginTop: '10px',
									boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
									borderRadius: '15px',
								}}>
								<Box>
									<Box
										onClick={() => (b ? setB(false) : setB(true))}
										style={{
											padding: '8px 20px',
											// display: inline-flex;
											textalign: 'center',
											backgroundColor: '#39c9bb',
											color: 'white',
											cursor: 'pointer',
											alignItems: 'center',
											width: '10%',
										}}>
										<BodyText>Baggage</BodyText>
									</Box>
									{b ? (
										<>
											<Box
												mt={'15px'}
												ml={'20px'}
												onMouseEnter={() => setVal(true)}
												onMouseLeave={() => setVal(false)}
												style={{
													display: 'block',
													padding: '6px',
													color: 'dark',
													backgroundColor: val ? '#39c9bb' : 'white',
													border: '1px solid #39c9bb',
													borderRadius: '4px',
													transition: 'all .3s',
													textAlign: 'center',
													width: '12%',
												}}>
												<BodyText>DEL-CCU</BodyText>
											</Box>
											<Box>
												<BaggageForm />
											</Box>
											<BodyText>Total Amount = ₹ 4000</BodyText>
											<BodyText one>
												Note: Pre-booked baggage is 15% cheaper than on-board
												price
											</BodyText>
										</>
									) : (
										''
									)}
								</Box>
							</Box>
							<Box
								style={{
									background: 'white',
									padding: '10px 15px',
									border: '1px solid #e6e6e6',
									marginTop: '10px',
									boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
									borderRadius: '15px',
								}}>
								<Box
									display='flex'
									alignItems='center'
									onClick={() => {
										dispatch(toggleGSTModal(true));
									}}>
									<TitleText textStyle={{ color: '#007bff' }}>
										Add GST Details
									</TitleText>
								</Box>
								<Box>
									<BodyText one>
										NOTE: (1) GSTIN can’t be updated once booking is completed.
										(2) Your Taxes may get updated post submitting GST details.
									</BodyText>
								</Box>
							</Box>
							<Box
								style={{
									background: 'white',
									padding: '10px 15px',
									border: '1px solid #e6e6e6',
									marginTop: '10px',
									boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
									borderRadius: '15px',
								}}>
								<FormControlLabel
									control={
										<GreenCheckbox
											checked={check}
											onChange={handleCheck}
											name='checkedG'
										/>
									}
									label='SpiceJet'
								/>
							</Box> */}
						</Grid>
						<Grid item xs={12} lg={4}>
							<Box
								style={{
									background: 'white',
									padding: '10px 15px',
									border: '1px solid #e6e6e6',
									marginTop: '10px',
									boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
									borderRadius: '15px',
									position: 'sticky',
									top: 10,
									zIndex: 1,
								}}>
								<Grid container alignItems='center'>
									<Grid item xs={4}>
										Fare Details
									</Grid>
									<Grid item xs={8}>
										<Divider style={{ background: 'black' }} />
									</Grid>
								</Grid>
								<Box
									style={{
										background: 'rgba(57,201,187,.17)',
										padding: '5px 10px',
										margin: '10px 0 0',
										borderRadius: '15px',
									}}>
									<BodyText>AMOUNT TO BE PAID</BodyText>
									<TitleText>
										{location.state.Returnflight
											? `Rs ${
													(Number(
														location.state
															? location.state.flightData[0].Fare.OfferedFare
															: ''
													) +
														Number(
															location.state
																? location.state.Returnflight[0].Fare
																		.OfferedFare
																: ''
														)) *
													Number(location.state.returnBody.AdultCount)
											  }`
											: location.state.OneflightData
											? `Rs ${
													Number(
														location.state
															? location.state.OneflightData.Fare.OfferedFare
															: ''
													) *
														Number(location.state.body.AdultCount) +
													Number(baggage ? baggage : '') +
													Number(baggageAdult2 ? baggageAdult2 : '') +
													Number(baggageAdult3 ? baggageAdult3 : '') +
													Number(baggageAdult4 ? baggageAdult4 : '') +
													Number(baggageAdult5 ? baggageAdult5 : '') +
													Number(baggageAdult6 ? baggageAdult6 : '') +
													Number(baggageAdult7 ? baggageAdult7 : '') +
													Number(baggageAdult8 ? baggageAdult8 : '') +
													Number(baggageAdult9 ? baggageAdult9 : '') +
													Number(baggageChild1 ? baggageChild1 : '') +
													Number(baggageChild2 ? baggageChild2 : '') +
													Number(baggageChild3 ? baggageChild3 : '') +
													Number(baggageChild4 ? baggageChild4 : '') +
													Number(baggageChild5 ? baggageChild5 : '') +
													Number(baggageChild6 ? baggageChild6 : '') +
													Number(baggageChild7 ? baggageChild7 : '') +
													Number(baggageChild8 ? baggageChild8 : '') +
													Number(baggageChild9 ? baggageChild9 : '') -
													Number(value ? 200 : '')
											  }`
											: ''}
									</TitleText>
									<span>(inclusive of all taxes.)</span>
								</Box>
								<Box display='flex' justifyContent='space-between' mt={'10px'}>
									<BodyText>
										Adultx
										{location.state.body
											? location.state.body.AdultCount
											: location.state.returnBody
											? location.state.returnBody.AdultCount
											: ''}
									</BodyText>
									<TitleText two>
										{location.state.Returnflight
											? `Rs ${
													Number(
														location.state
															? location.state.flightData[0].Fare.OfferedFare
															: ''
													) * Number(location.state.returnBody.AdultCount)
											  }`
											: location.state.OneflightData
											? `Rs ${
													Number(
														location.state
															? location.state.OneflightData.Fare.OfferedFare
															: ''
													) *
														Number(location.state.body.AdultCount) +
													Number(baggage ? baggage : '') +
													Number(baggageAdult2 ? baggageAdult2 : '') +
													Number(baggageAdult3 ? baggageAdult3 : '') +
													Number(baggageAdult4 ? baggageAdult4 : '') +
													Number(baggageAdult5 ? baggageAdult5 : '') +
													Number(baggageAdult6 ? baggageAdult6 : '') +
													Number(baggageAdult7 ? baggageAdult7 : '') +
													Number(baggageAdult8 ? baggageAdult8 : '') +
													Number(baggageAdult9 ? baggageAdult9 : '') +
													Number(baggageChild1 ? baggageChild1 : '') +
													Number(baggageChild2 ? baggageChild2 : '') +
													Number(baggageChild3 ? baggageChild3 : '') +
													Number(baggageChild4 ? baggageChild4 : '') +
													Number(baggageChild5 ? baggageChild5 : '') +
													Number(baggageChild6 ? baggageChild6 : '') +
													Number(baggageChild7 ? baggageChild7 : '') +
													Number(baggageChild8 ? baggageChild8 : '') +
													Number(baggageChild9 ? baggageChild9 : '') -
													Number(value ? 200 : '')
											  }`
											: ''}
									</TitleText>
								</Box>
								{baggage || baggageChild1 ? (
									<Box display='flex' justifyContent='space-between'>
										<BodyText>Add-Ons</BodyText>
										<TitleText two>{`Rs ${
											Number(baggage ? baggage : '') +
											Number(baggageAdult2 ? baggageAdult2 : '') +
											Number(baggageAdult3 ? baggageAdult3 : '') +
											Number(baggageAdult4 ? baggageAdult4 : '') +
											Number(baggageAdult5 ? baggageAdult5 : '') +
											Number(baggageAdult6 ? baggageAdult6 : '') +
											Number(baggageAdult7 ? baggageAdult7 : '') +
											Number(baggageAdult8 ? baggageAdult8 : '') +
											Number(baggageAdult9 ? baggageAdult9 : '') +
											Number(baggageChild1 ? baggageChild1 : '') +
											Number(baggageChild2 ? baggageChild2 : '') +
											Number(baggageChild3 ? baggageChild3 : '') +
											Number(baggageChild4 ? baggageChild4 : '') +
											Number(baggageChild5 ? baggageChild5 : '') +
											Number(baggageChild6 ? baggageChild6 : '') +
											Number(baggageChild7 ? baggageChild7 : '') +
											Number(baggageChild8 ? baggageChild8 : '') +
											Number(baggageChild9 ? baggageChild9 : '')
										}`}</TitleText>
									</Box>
								) : (
									''
								)}

								<Box display='flex' justifyContent='space-between'>
									<BodyText>Total Taxes</BodyText>
									<TitleText two>Rs 50</TitleText>
								</Box>
								<Divider />
								{value ? (
									<Box
										display='flex'
										justifyContent='space-between'
										mt={'5px'}
										mb={'5px'}>
										<BodyText>Convenience Fees</BodyText>
										<TitleText two>Rs 200</TitleText>
									</Box>
								) : (
									''
								)}

								<Divider />
							</Box>
							<Box
								style={{
									background: 'white',
									padding: '10px 15px',
									border: '1px solid #e6e6e6',
									marginTop: '10px',
									boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
									borderRadius: '15px',
									position: 'sticky',
									top: 280,
									zIndex: 1,
								}}>
								<Grid container alignItems='center'>
									<Grid item xs={4}>
										Promo Code
									</Grid>
									<Grid item xs={8}>
										<Divider style={{ background: 'black' }} />
									</Grid>
								</Grid>
								<Box>
									<RadioGroup
										aria-label='gender'
										name='gender1'
										value={value}
										// onChange={handleChange}
									>
										<FormControlLabel
											value='female'
											control={<Radio onClick={handleClick} />}
											label='NOFEES'
										/>
										<BodyText one textStyle={{ marginLeft: 10 }}>
											Use this promo ad save 200
										</BodyText>
									</RadioGroup>
								</Box>
							</Box>
						</Grid>
					</Grid>
					{/* <Grid container style={{ marginTop: 20, marginBottom: 20 }}>
						<Grid item xs={3}></Grid>
						<Grid item xs={3}>
							<Box
								style={{
									textAlign: 'center',
									background: '#1593ff',
									color: 'white',
									padding: '8px 30px',
									margin: '5px 0 0',
									cursor: 'pointer',
									borderRadius: 10,
								}}>
								Proceed to Payment
							</Box>
						</Grid>
						<Grid item xs={3}></Grid>
					</Grid> */}
				</Container>
			</Box>
			<AddGSTModal />
			<TermConditionModal />
			<Drawers />
			<Login />
		</>
	);
};

export default FlightSummary;
